const listeners = new Set();
let requestSequence = 0;

export function proposalDiscussionDraft(description) {
  const normalized = String(description || '').trim();
  return normalized ? `Regarding your suggestion “${normalized}”: ` : 'Regarding your suggested change: ';
}

export function publishWorkoutCoachDiscussionRequest({ workoutId, workoutExerciseId, description } = {}) {
  const normalizedWorkoutId = String(workoutId || '').trim();
  const normalizedExerciseId = String(workoutExerciseId || '').trim();
  if (!normalizedWorkoutId || !normalizedExerciseId) return false;
  requestSequence += 1;
  const request = {
    key: `${normalizedWorkoutId}:${normalizedExerciseId}:${requestSequence}`,
    workoutId: normalizedWorkoutId,
    workoutExerciseId: normalizedExerciseId,
    description: String(description || '').trim(),
    draftText: proposalDiscussionDraft(description),
  };
  listeners.forEach(listener => listener(request));
  return true;
}

export function subscribeWorkoutCoachDiscussionRequests(listener) {
  if (typeof listener !== 'function') return () => {};
  listeners.add(listener);
  return () => listeners.delete(listener);
}
